<template>
  <div class="our-cars">
    <h1>Our cars</h1>
    <div class="our-cars-items">
      <div class="our-cars-item black-car" @click="openModal(0)"></div>
      <div class="our-cars-item white-car" @click="openModal(1)"></div>
      <div class="our-cars-item van-car" @click="openModal(2)"></div>
    </div>
    <transition name="fade">
      <div class="our-cars-preview" v-if="isModalOpened">
        <span class="close-preview" @click="closeModal()">
          <span>+</span>
        </span>
        <div v-if="car === 0" class="our-cars-preview-image black-car"></div>
        <div v-if="car === 1" class="our-cars-preview-image white-car"></div>
        <div v-if="car === 2" class="our-cars-preview-image van-car"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpened: false,
      car: undefined
    };
  },
  methods: {
    openModal(car) {
      this.isModalOpened = true;
      this.car = car
      
    },
    closeModal() {
      this.isModalOpened = false;
      this.car = undefined;
    }
  }
};
</script>

<style>
.our-cars {
  align-items: center;
  background-color: #f3f3f3;
  background-image: url("../assets/img/cover_blur.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  padding: 20px;
  width: 100%;
}
.our-cars h1,
.our-cars p {
  color: #fff;
  text-align: center;
  width: 100%;
}
.our-cars p {
  margin: 10px 0;
}
.our-cars a {
  white-space: nowrap;
}
.our-cars-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}
.our-cars-item {
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  cursor: pointer;
  height: 150px;
  margin: 5px;
  overflow: hidden;
  position: relative;
  width: 150px;
}
.black-car {
  background-image: url("../assets/img/cars/black.jpg");
}
.white-car {
  background-image: url("../assets/img/cars/white.jpg");
}
.van-car {
  background-image: url("../assets/img/cars/van.jpg");
}
.our-cars-item::before {
  border: 1px solid #fff;
  border-radius: 6px;
  content: "";
  height: 144px;
  left: 3px;
  opacity: 0;
  position: absolute;
  top: 3px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 144px;
}
.our-cars-item:hover::before {
  opacity: 1;
}
.our-cars-preview {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  height: 100%;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.our-cars-preview-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 90%;
  width: 90%;
}
.close-preview {
  align-items: center;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 40px;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 40px;
}
.close-preview:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.close-preview span {
  transform: rotate(45deg);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cars.vue